import { BaseDisplaySet } from './BaseDisplaySet.js';
function collectUnderlyingImageIds(instances) {
    const ids = [];
    for (const instance of instances) {
        if (instance.imageId) {
            ids.push(instance.imageId);
        }
    }
    return ids;
}
function collectImageIds(instances, underlyingImageIds) {
    const imageIds = [];
    for (const instance of instances) {
        if (instance.imageId) {
            imageIds.push(instance.imageId);
        }
    }
    if (imageIds.length === 0) {
        return [...underlyingImageIds];
    }
    return imageIds;
}
export class ImageStackDisplaySet extends BaseDisplaySet {
    constructor(options) {
        const instances = options.instances ?? [];
        const underlyingImageIds = options.underlyingImageIds ?? collectUnderlyingImageIds(instances);
        const underlyingList = [...underlyingImageIds];
        const imageIds = options.imageIds ?? collectImageIds(instances, underlyingList);
        super({
            ...options,
            instances,
            imageIds,
            underlyingImageIds: underlyingList,
        });
        this.isMultiFrame = instances.some((instance) => Number(instance.NumberOfFrames) > 1);
    }
    static fromInstances(instances, options) {
        const displaySetId = options?.displaySetId ??
            instances[0]?.SeriesInstanceUID ??
            `display-set-${instances[0]?.imageId ?? 'unknown'}`;
        return new ImageStackDisplaySet({
            displaySetId,
            viewportTypes: options?.viewportTypes ?? ['stack', 'volume', 'volume3d'],
            instances,
            imageIds: options?.imageIds,
        });
    }
    static fromImageIds(imageIds, getNaturalizedInstance, options) {
        const instances = imageIds
            .map((imageId) => getNaturalizedInstance(imageId))
            .filter((instance) => instance !== undefined);
        return ImageStackDisplaySet.fromInstances(instances, {
            ...options,
            imageIds,
        });
    }
}
